// OrderBooksComponent.js



import React, { useEffect, useCallback, useState, useRef } from 'react';
import { connect } from "react-redux";
import { useParams, useNavigate } from 'react-router-dom';
import { useImmer } from 'use-immer';
import axios from 'axios';
import * as config from "../../assets/js/constant.js";
import useRazorpay from "react-razorpay";

import {
  Box,
  Button,
  Container,
  Divider,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
  CircularProgress
} from '@mui/material';
import '../OrderBooksComponent/OrderBooksComponent.css';

import HeaderComponent from '../../common/HeaderComponent/HeaderComponent';
import ShippingAddressComponent from '../ShippingAddressComponent/ShippingAddressComponent';
import BooksOrderConfirmComponent from '../BooksOrderConfirmComponent/BooksOrderConfirmComponent';
import BookPaymentDetailsComponent from '../BookPaymentDetailsComponent/BookPaymentDetailsComponent';
import BottomAppBarComponent from '../../common/BottomAppBarComponent/BottomAppBarComponent';
import FooterComponent from '../../common/FooterComponent/FooterComponent';
import { getBookdetails } from '../../store/actions/book.js';
import { setorderBookingDetails } from '../../store/actions/book.js';
import { bookPaymentProcess } from '../../store/actions/book.js';
import { bookComplete } from '../../store/actions/book.js';
import { booksUserDetails } from '../../store/actions/book.js';



const OrderBooksComponent = ({

  getBookdetails,
  bookDetails,
  setorderBookingDetails,
  bookOrderDetails,
  bookPaymentProcess,
  bookComplete,
  booksUserDetails

}) => {

  // Add this helper in OrderBooksComponent.js
const reloadRazorpayScript = () => {
  return new Promise((resolve) => {
    const existing = document.querySelector(
      'script[src="https://checkout.razorpay.com/v1/checkout.js"]'
    );
    if (existing) existing.remove();

    const script = document.createElement('script');
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = resolve;
    document.body.appendChild(script);
  });
};

  const navigate = useNavigate();

  const orderIdRef = useRef(null);

  const triggerMailOnClose = useCallback(() => {
    if (orderIdRef.current) {
      // Shouts the OrderID to the server even if the tab is closing
      const url = config.API_BASE_URL + `apiCall.php?apicall=triggerMailOnClose&OrderID=${orderIdRef.current}`;
      navigator.sendBeacon(url);
    }
  }, []);

  // Redirect to MyBooksComponent if no books are selected (on refresh/direct access)
  useEffect(() => {
    if (!bookOrderDetails || bookOrderDetails.length === 0) {
      navigate('/get-books/');
    }
  }, [bookOrderDetails, navigate]);

  useEffect(() => {
    window.addEventListener("beforeunload", triggerMailOnClose);
    return () => {
      window.removeEventListener("beforeunload", triggerMailOnClose);
    };
  }, [triggerMailOnClose]);

  const BOOKUSERVALUE = {
    entity: { value: "BOOK" },
    bookUserName: {
      value: "",
      isValid: false,
      errorMessage: "User name not valid!!"
    },
    bookUserAddress: {
      value: "",
      isValid: false,
      errorMessage: "Email address not valid!!"
    },
    bookUserPincode: {
      value: "",
      isValid: false,
      errorMessage: "Please enter a valid Pincode"
    },
    bookUserContact: {
      value: "",
      isValid: false,
      errorMessage: "Please enter a valid contact number"
    },
    bookUserEmail: {
      value: "",
      isValid: false,
      errorMessage: "Please enter valid email"
    },
    bookUserComments: {
      value: "",
      isValid: true,
      errorMessage: "Comments should not exceed 120 characters."
    },
    userPanNo: {
      value: "",
      isValid: true,
      errorMessage: "Please enter valid Pan Number"
    },


  }


  const BOOKPAYMENTVALUES = {
    bookUserEmail: {
      value: "",
      isValid: false,
      errorMessage: "Please enter valid email"
    },
    bookUserComments: {
      value: "",
      isValid: true,
      errorMessage: "Comments should not exceed 120 characters."
    },
    OrderID: {
      value: "",
    },
  }


  const USERVALUE = {
    subTotal: 0,
    total: 0
  };




  const [getuserBookdetails, setuserBookdetails] = useImmer(BOOKUSERVALUE);
  const [getuserDetails, setuserDetails] = useImmer(USERVALUE);
  const [getBookPaymentDetails, setBookPaymentDetails] = useImmer(BOOKPAYMENTVALUES);
  const [shippingLoading, setShippingLoading] = useImmer(false); // <-- Loader for shipping
  const [orderConfirmShippingLoading, setOrderConfirmShippingLoading] = useState(false); // <-- Add this state


  const [getloader, setloader] = useImmer(false);

  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleEdit = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };




  const steps = [
    {
      label: 'Ship To',
      ShipTo: <ShippingAddressComponent getuserBookdetails={getuserBookdetails} setuserBookdetails={setuserBookdetails} />,
      nextStep: async function () {
        // Show loader
        setloader(true);

        // Alternate Number is optional, but if the field exists it must be
        // valid (10 digits, not all zeros, and not equal to the Contact
        // Number) — mirrors the check performed inside
        // ShippingAddressComponent's handlePersonAltNumber.
        const isAltNumberValid =
          !getuserBookdetails.bookUserAlt || getuserBookdetails.bookUserAlt.isValid;

        // Validate all fields before API call
        if (
          getuserBookdetails.bookUserName.isValid &&
          getuserBookdetails.bookUserAddress.isValid &&
          getuserBookdetails.bookUserPincode.value &&
          getuserBookdetails.bookUserContact.isValid &&
          isAltNumberValid &&
          getuserBookdetails.bookUserEmail.isValid &&
          getuserBookdetails.bookUserComments.isValid &&
          getuserBookdetails.userPanNo.isValid

        ) {
          try {
            // Call shipmentCharges API to validate pincode
            const response = await axios.post(
              config.API_BASE_URL + 'apiCall.php?apicall=shipmentCharges',
              {
                pincode: getuserBookdetails.bookUserPincode.value,
                books: bookOrderDetails
              }
            );
            const data = response.data;
            if (data.Status) {
              // Pincode valid, proceed
              setuserBookdetails((draft) => {
                draft.bookUserPincode.isValid = true;
                draft.bookUserPincode.errorMessage = "";
              });

              const shippingValues = Object.keys(getuserBookdetails).reduce((acc, key) => {
                acc[key] = getuserBookdetails[key].value;
                return acc;
              }, {});

              // Store shipping details in Redux
              setorderBookingDetails({ shippingDetails: shippingValues });

              setuserDetails((draft) => {
                draft.bookUserName = shippingValues.bookUserName;
                draft.bookUserAddress = shippingValues.bookUserAddress;
                draft.bookUserAlt = shippingValues.bookUserAlt;
                draft.bookUserPincode = shippingValues.bookUserPincode;
                draft.bookUserContact = shippingValues.bookUserContact;
                draft.bookUserEmail = shippingValues.bookUserEmail;
                draft.bookUserComments = shippingValues.bookUserComments;
                draft.userPanNo = shippingValues.userPanNo;
              });
              booksUserDetails({
                "pincode": shippingValues.bookUserPincode,
                "books": bookOrderDetails
              });
              handleNext();
            } else {
              // Invalid pincode, show error
              setuserBookdetails((draft) => {
                draft.bookUserPincode.isValid = false;
                draft.bookUserPincode.errorMessage = data.Message || "Invalid Pincode";
              });
            }
          } catch (err) {
            setuserBookdetails((draft) => {
              draft.bookUserPincode.isValid = false;
              draft.bookUserPincode.errorMessage = "Error validating pincode";
            });
          }
        }
        setloader(false);
      },
      buttons: ['Next']
    },
    {
      label: 'Confirmation',
      OrderConfirmation: <BooksOrderConfirmComponent
        getuserDetails={getuserDetails}
        setuserDetails={setuserDetails}
        shippingLoading={shippingLoading} // <-- Pass loader as prop (legacy, can be removed if not used)
        onShippingLoadingChange={setOrderConfirmShippingLoading} // <-- Pass callback
      />,

      nextStep: function () {
        setloader(true);
        handlePayment(bookOrderDetails, getuserDetails);
      },
      buttons: ['Back', 'PayNow']
    },
  ];


  const renderButtons = (step) => {
    return step.buttons.map((button, index) => {
      switch (button) {
        case 'Back':
          return (
            <Button sx={{ mt: 1, mr: 1, color: 'grey', borderColor: 'grey !important' }} variant="outlined" key={index} onClick={handleBack}>
              Back
            </Button>
          );
        case 'Next':
          return (
            <Button sx={{ mt: 1, mr: 1 }} variant="contained" key={index} onClick={step.nextStep}>
              Next
            </Button>
          );
        case 'Submit':
          return (
            <Button sx={{ mt: 1, mr: 1 }} variant="contained" key={index} onClick={step.nextStep}>
              Submit
            </Button>
          );
        case 'Edit':
          return (
            <Button sx={{ mt: 1, mr: 1, color: 'grey', borderColor: 'grey !important' }} variant="outlined" key={index} onClick={handleEdit}>
              Edit
            </Button>
          );
        case 'PayNow':
          return (
            <Button
              sx={{ mt: 1, mr: 1 }}
              variant="contained"
              key={index}
              onClick={step.nextStep}
              disabled={orderConfirmShippingLoading} // <-- Disable when loader is active
            >
              Pay Now
            </Button>
          );
        default:
          return null;
      }
    });
  };


  const [Razorpay] = useRazorpay();


  const handlePayment = useCallback((bookOrderDetails, shippingDetails) => {
    const mergedOrderDetails = {
      shippingDetails,
      bookDetails: bookOrderDetails,
    };

    setloader(true); // Start loader

    axios.post(config.API_BASE_URL + 'apiCall.php?apicall=bookOrderCreation', { data: mergedOrderDetails })
  .then(async response => {
    const data = response.data.Data;
    const orderId = data.OrderID;
    orderIdRef.current = orderId;

    await reloadRazorpayScript(); // <-- force a clean Razorpay instance every time

    const options = {
      key: data.key_id,
      amount: data.Amount,
      currency: data.Currency,
      name: "NSR Trust",
      description: "Ordering Book(s) from Sarvamangala Trust.",
      image: "https://sridevitemple.com/images/god-image.jpg",
      order_id: orderId,
      handler: (res) => {
        orderIdRef.current = null;
        bookPaymentProcess(res);
        navigate("/book-success", { state: { bookUserEmail: shippingDetails.bookUserEmail } });
        setloader(false);
      },
      prefill: {
        name: shippingDetails.bookUserName,
        contact: shippingDetails.bookUserContact
      },
      theme: { color: "#3399cc" },
      modal: { ondismiss: () => setloader(false) }
    };

    const rzpay = new window.Razorpay(options); // use window.Razorpay since we just re-injected the script
    rzpay.open();
    setloader(false);
  })
  .catch(error => {
    console.log(error);
    setloader(false);
  });
  }, [Razorpay, bookPaymentProcess, navigate, setloader]);


  // Watch for bookOrderDetails change and update shipping charges
  useEffect(() => {
    // Only call if shippingDetails.pincode is available
    if (!getuserDetails.bookUserPincode) return;
    setShippingLoading(true);
    axios.post(
      config.API_BASE_URL + 'apiCall.php?apicall=shipmentCharges',
      {
        pincode: getuserDetails.bookUserPincode,
        books: bookOrderDetails
      }
    ).then(response => {
      if (response.data.Status) {
        booksUserDetails({
          pincode: getuserDetails.bookUserPincode,
          books: bookOrderDetails
        });
      }
    }).finally(() => {
      setShippingLoading(false);
    });
  }, [bookOrderDetails, getuserDetails.bookUserPincode, booksUserDetails, setShippingLoading]);



  return (
    <>
      <HeaderComponent />
      <Box className="order-my-books-screen">
        <Container>
          <Box sx={{ py: 2 }}>
            <Stepper activeStep={activeStep} orientation="vertical">
              {steps.map((step, index) => (
                <Step key={step.label} >
                  <Box className="stepper-label">
                    <StepLabel>
                      {step.label}
                    </StepLabel>
                  </Box>
                  <StepContent>
                    <Typography>{step.description}</Typography>
                    {step.ShipTo}
                    {step.OrderConfirmation}
                    {step.PaymentDetails}
                    {steps[activeStep] && (
                      <Box className="stepContent-btn" sx={{ mb: 2, textAlign: 'right', mx: 20 }}>
                        {getloader ? (<Box sx={{ mt: 1, mr: 1 }} variant="contained"><CircularProgress /></Box>) : renderButtons(steps[activeStep])}
                      </Box>
                    )}
                    <Divider />
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          </Box>
        </Container>
        <FooterComponent />
      </Box>
      <BottomAppBarComponent />
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    bookDetails: state.book.bookDetails,
    bookOrderDetails: state.book.bookOrderDetails
  };
}

export default connect(mapStateToProps, {

  getBookdetails,
  setorderBookingDetails,
  bookPaymentProcess,
  bookComplete,
  booksUserDetails

})(OrderBooksComponent);